export function view(value) {
  return value ? (value.startsWith('image/') ? 'ImageFile' : 'OtherFile') : 'No'
}
